import type { ReactNode } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useAppTheme } from "@core/theme";

export type PageHeaderProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
};

export const PageHeader = ({ title, description, actions }: PageHeaderProps) => {
  const { theme, colors } = useAppTheme();

  return (
    <Flex align="flex-start" justify="space-between" gap={4} mb={6} wrap="wrap">
      <Box minW={0}>
        <Box
          as="h1"
          color={colors.header[900]}
          fontFamily={theme.fonts.heading}
          fontSize={theme.fontSizes["2xl"]}
          fontWeight={theme.fontWeights.semibold}
          lineHeight={theme.lineHeights.short}
        >
          {title}
        </Box>
        {description !== undefined && (
          <Box
            as="p"
            mt={1}
            color={colors.text[500]}
            fontFamily={theme.fonts.body}
            fontSize={theme.fontSizes.sm}
          >
            {description}
          </Box>
        )}
      </Box>
      {actions !== undefined && <Flex gap={3}>{actions}</Flex>}
    </Flex>
  );
};
